import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import {ApiService, CategoriesService, CouponUnit, Deal, DealsService, PromotionType} from '../core';
import {PrefilledDealModel} from '../core/models/prefilled-deal.model';
import {Category} from '../core/models/category.model';
import {ErrorUtil} from '../core/utils/error.util';
import {MenuItem} from 'primeng/api';
import {tap} from 'rxjs/operators';
import {ServerResponse} from '../core/models/server-response.model';
import {NgxDropzoneChangeEvent} from 'ngx-dropzone';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-editor-page',
  templateUrl: './edit.component.html'
})
export class EditComponent implements OnInit {
  deal: PrefilledDealModel = {} as PrefilledDealModel;
  isSubmitting = false;
  dealUrl: string;
  firstStep = true;
  lastStep = false;
  categories: Array<Category> = [];
  couponTypes: CouponUnit[];
  selectedCouponType: CouponUnit;
  dealImages = '';
  loadingDetails = false;
  errorPresent = false;
  serverError: ErrorUtil;
  steps: MenuItem[];
  activeIndex = 0;
  offersType: any[];
  selectedFile: File = null;

  constructor(
    private dealsService: DealsService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private apiService: ApiService,
    private categoriesService: CategoriesService,
    private translateService: TranslateService
  ) {
    this.steps = [
      {label: translateService.instant('edit_deal_progress1')},
      {label: translateService.instant('edit_deal_progress2')}
    ];
    this.offersType = [
      {label: translateService.instant('discount'), value: PromotionType.none.valueOf()},
      {label: translateService.instant('promo_code'), value: PromotionType.promocode.valueOf()},
      {label: translateService.instant('promo_type_cart_discount'), value: PromotionType.CartDiscount.valueOf()},
      {label: translateService.instant('promo_type_amz_flash'), value: PromotionType.AmazonFlash.valueOf()},
      {label: translateService.instant('promo_type_page_discount'), value: PromotionType.AmazonCoupon.valueOf()},
      {label: translateService.instant('promo_type_amz_flash_code'), value: PromotionType.AmazonCouponAndFlash.valueOf()},
      {label: translateService.instant('cashback'), value: PromotionType.Cashback.valueOf()}
    ];
    this.couponTypes = [
      {name: '%', code: 1, class: 'p-button-dlnd'},
      {name: translateService.instant('currency_unit'), code: 2, class: 'p-button-dlnd'}
    ];
    this.categoriesService.currentCategories.subscribe( data =>
        this.categories = data
    );
  }

  ngOnInit() {
    // If there's an deal prefetched, load it
    this.route.data.subscribe((data) => {
      const actualDeal: Deal = data.deal.deal;
      if (data.deal) {
        this.deal.linkID = actualDeal.link_id;
        this.deal.imageURL = actualDeal.file_name;
        this.deal.priceDeal = actualDeal.link_price;
        this.deal.priceOld = actualDeal.link_list_price;
        this.deal.shipping = actualDeal.link_shipping;
        this.deal.content = actualDeal.link_content;
        this.deal.title = actualDeal.link_title;
        this.deal.coupon = actualDeal.link_coupon;
        this.deal.promoCode = actualDeal.link_promo_code;
        this.deal.promotionType = actualDeal.link_promotion_type;
        this.deal.category = actualDeal.link_category;
        this.deal.store = actualDeal.link_store;
        if (this.deal.coupon > 0) {
          this.selectedCouponType = this.couponTypes[1];
        } else {
          this.selectedCouponType = this.couponTypes[0];
        }
      }
    });
  }
  submitDeal() {
    this.isSubmitting = true;
    // post the changes
    if (this.selectedFile !== null) {
      this.apiService.upload(this.selectedFile).subscribe( data =>
          this.handleImageUploaded(data)
      );
    } else {
      this.sendDealEdit();
    }
  }
  handleImageUploaded(imageResponse: ServerResponse) {
    if (imageResponse.ok) {
      this.deal.imageURL = imageResponse.uploadURL;
      this.sendDealEdit();
    } else {
      this.handleError(imageResponse);
    }
  }
  sendDealEdit() {
    this.dealsService.update(this.deal, this.selectedCouponType.code).subscribe(
        resp => this.handleLastStepSubmission(resp),
        err => {
          this.handleError(err);
          this.isSubmitting = false;
        }
    );
  }
  handleError(err: ServerResponse) {
    this.serverError = new ErrorUtil(err.error);
    this.errorPresent = true;
    this.isSubmitting = false;
  }
  onSelect($event: NgxDropzoneChangeEvent) {
    this.selectedFile = $event.addedFiles.pop();
    this.deal.imageURL = null;
  }
  handleLastStepSubmission(resp: ServerResponse) {
    if (resp.ok) {
      this.activeIndex = 1;
      this.firstStep = false;
      this.lastStep = true;
    } else {
      this.handleError(resp);
    }
  }
  fileChange($event) {
    const files: FileList = $event.target.files;
    if (files.length > 0) {
      const file: File = files[0];
      this.apiService.upload(file).subscribe();
    }
  }
}
